import { render, staticRenderFns } from "./InterSettings.vue?vue&type=template&id=012b0bff"
import script from "./InterSettings.vue?vue&type=script&lang=js"
export * from "./InterSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports